import React, { useEffect, useState } from 'react';
import { Box, Tooltip, Typography } from '@mui/material';
import { buildInfo } from '../config/buildInfo';
import {
  formatApiVersionTooltip,
  getApiVersion,
  type ApiVersionInfo,
} from '../services/versionService';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  const [apiVersion, setApiVersion] = useState<ApiVersionInfo | null>(null);

  useEffect(() => {
    let cancelled = false;
    getApiVersion()
      .then((info) => {
        if (!cancelled) setApiVersion(info);
      })
      .catch(() => {
        if (!cancelled) setApiVersion(null);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <Box
      component="footer"
      sx={{
        mt: 'auto',
        py: 2,
        px: 3,
        backgroundColor: '#ffffff',
        borderTop: '1px solid rgba(0, 0, 0, 0.12)',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: 1,
      }}
    >
      <Tooltip title={formatApiVersionTooltip(apiVersion)} arrow>
        <Typography
          variant="caption"
          sx={{
            color: 'text.secondary',
            fontSize: '0.75rem',
            cursor: 'default',
          }}
        >
          v{buildInfo.version} Build {buildInfo.buildNumber}
        </Typography>
      </Tooltip>
      <Typography
        variant="caption"
        sx={{
          color: 'text.secondary',
          fontSize: '0.75rem',
        }}
      >
        Copyright © {currentYear} Neos. Todos los derechos reservados.
      </Typography>
    </Box>
  );
};

export default Footer;
